import React from "react";
import { Star, Quote } from "lucide-react";
import { TESTIMONIALS } from "@/data/landing";
import { Reveal } from "@/components/landing/primitives";

export const TestimonialsSection = () => (
  <section id="stories" data-testid="testimonials-section" className="py-24 lg:py-32 bg-afwn-surface">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal>
        <div className="text-center max-w-2xl mx-auto">
          <p className="text-sm tracking-wider uppercase font-semibold text-afwn-magenta">Real Stories</p>
          <h2 className="mt-3 font-heading font-light tracking-tight text-4xl lg:text-5xl">Calm, found again</h2>
        </div>
      </Reveal>
      <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-8">
        {TESTIMONIALS.map((t, i) => (
          <Reveal key={t.name} i={i}>
            <div data-testid={`testimonial-${i + 1}`} className="bg-white rounded-3xl p-8 h-full border border-afwn-navy/5 shadow-sm">
              <Quote size={32} className="text-afwn-magenta/30" />
              <div className="flex text-afwn-amber mt-3">{[...Array(5)].map((_, k) => <Star key={`star-${k}`} size={15} fill="currentColor" />)}</div>
              <p className="mt-4 text-afwn-slate leading-relaxed italic">{t.text}</p>
              <div className="mt-6 flex items-center gap-3">
                <img src={t.img} alt={t.name} data-testid={`testimonial-avatar-${i + 1}`} className="w-12 h-12 rounded-full object-cover border-2 border-afwn-surface" />
                <div>
                  <p className="font-medium text-afwn-navy leading-tight">{t.name}</p>
                  <p className="text-xs text-afwn-slate">{t.role}</p>
                </div>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
